<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <!-- Main content -->
      <section class="content-noneheader">
        <!-- Multiple select-->
        <div class="box">
          <div class="box-header with-border">
            <el-breadcrumb separator="/">
              <template v-if="this.$route.query.customerId">
                <el-breadcrumb-item>客户管理</el-breadcrumb-item>
                <el-breadcrumb-item :to="{path: '/customer/customerEmpList'}">我的客户</el-breadcrumb-item>
                <el-breadcrumb-item>服务提醒</el-breadcrumb-item>
              </template>
              <template v-else>
                <el-breadcrumb-item>客户管理</el-breadcrumb-item>
                <el-breadcrumb-item>服务提醒</el-breadcrumb-item>
              </template>
            </el-breadcrumb>
          </div>
          <div class="box-body" style="min-height:80%;">
            <div class="search-div">
              <template v-if="customerId == null">
                <el-input v-model="createName" placeholder="请输创建用户昵称"
                          class="input-size-200 input-margin-right"></el-input>
                <el-input v-model="infoName" placeholder="请输入客户姓名" class="input-size-200 input-margin-right"></el-input>
                <el-input v-model="toName" placeholder="请输服务用户昵称" class="input-size-200 input-margin-right"></el-input>
                <el-date-picker v-model="beginAt" type="date" value-format="yyyy-MM-dd" placeholder="选择开始日期" class="input-size-200 input-margin-right"></el-date-picker>
              </template>
              <el-button type="success" icon="el-icon-plus" class="button-pull-right" style="margin-left: 20px"
                         @click="handleCreate()">新增
              </el-button>
              <template v-if="customerId == null">
                <el-button type="primary" icon="el-icon-search" class="button-pull-right" @click="search()">搜索
                </el-button>
              </template>
              <br/>
            </div>
            <el-table
              ref="multipleTable"
              :data="dt.data"
              :stripe="true"
              border
              highlight-current-row
              style="width: 100%"
              :size="dt.size"
              @sort-change="dt.handleSortChange"
              @selection-change="dt.handleSelectionChange">
              <el-table-column
                type="selection"
                min-width=5%>
              </el-table-column>
              <el-table-column
                property="id"
                label="ID"
                min-width=5%>
              </el-table-column>
              <el-table-column
                property="customerInfo.name"
                label="服务客户名称"
                min-width=10%
                sortable="custom">
              </el-table-column>
              <el-table-column
                property="toUser.name"
                label="服务系统用户昵称"
                min-width=10%
                sortable="custom">
              </el-table-column>
              <el-table-column
                property="remark"
                label="备注"
                min-width=20%
                sortable="custom">
              </el-table-column>
              <el-table-column
                property="beginAt"
                :formatter="dateFormat"
                label="开始日期"
                min-width=10%
                sortable="custom">
              </el-table-column>
              <el-table-column
                property="endAt"
                :formatter="dateFormat"
                label="结束日期"
                min-width=10%
                sortable="custom">
              </el-table-column>
              <el-table-column
                property="commonStatus"
                label="状态"
                min-width=10%
                sortable="custom"
                :formatter="commonStatusFormat">
              </el-table-column>
              <el-table-column
                property="createUser.staffName"
                label="创建用户"
                min-width=10%
                sortable="custom">
              </el-table-column>
              <el-table-column
                property="loopType"
                label="是否重复"
                min-width=10%
                sortable="custom"
                :formatter="booleanFormat">
              </el-table-column>
              <el-table-column
                property="loopInterval"
                label="间隔"
                min-width=10%
                sortable="custom">
              </el-table-column>
              <el-table-column label="操作" min-width=20%>
                <template slot-scope="scope" v-if="scope.row.commonStatus === 'EFFECTIVE'">
                  <el-button
                    size="mini"
                    @click="handleEdit(scope.$index, scope.row)">编辑
                  </el-button>
                  <el-button
                    size="mini"
                    type="danger"
                    :plain="true" @click="handleDelete(scope.$index, scope.row)">刪除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @size-change="dt.handleSizeChange"
              @current-change="dt.handleCurrentChange"
              :current-page="dt.currentPage"
              :page-sizes="dt.pageSizes"
              :page-size="dt.pageSize"
              :layout="dt.layout"
              :total="dt.totalElements">
            </el-pagination>
          </div>
        </div>
        <!-- End of Multiple select-->
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>

<script>
  import {DataTable} from "../../../data-table";
  import {CommonUtil} from "../../../global";
  import {SystemMemoService} from "../../../system-memo-service";

  export default {
    name: "SystemMeoList",
    data: function () {
      return {
        customerId: null, // 区分是我的客户模式 还是 通用管理模式
        toName: null,
        createName: null,
        infoName: null,
        beginAt: null,
        dt: null
      }
    },
    // 多个入口重用一个页面，需要监听路由变化
    beforeRouteUpdate: function (to, from, next) {
      // 所有动态参数逻辑应该封装在 viewInit() 方法内，mounted() 也能监听
      this.viewInit(to.query);
      next();
    },
    mounted: function () {
      let queryMap = this.$route.query;
      this.viewInit(queryMap);
    },
    methods: {
      // 页面初始化（增加动态参数要在这里接收）
      viewInit: function (queryMap) {
        this.customerId = queryMap.customerId;

        if (this.customerId) { // 区分是我的客户模式
          this.dt = DataTable.getInstance(this, '/admin/systemMemo/findPageByCreateUser');
          let filters = [];
          let key = {};
          key.name = 'customerInfo.id';
          key.type = 'number';
          key.value = this.customerId;
          filters.push(key);
          this.dt.filters = filters;
        } else { // 通用管理模式
          this.dt = DataTable.getInstance(this, '/admin/systemMemo/findPage');
          //  还原过滤设置
          let filters = this.dt.filters;
          if (filters != null && filters instanceof Array) {
            for (let i = 0; i < filters.length; i++) {
              let f = filters[i];
              switch (f.name) {
                case "toUser.name":
                  this.toName = f.value;
                  continue;
                case "createUser.name":
                  this.createName = f.value;
                  continue;
                case "customerInfo.name":
                  this.infoName = f.value;
                  continue;
                case "beginAt":
                  this.beginAt = f.value;
                  continue;
              }
            }
          }
        }

        //  向后台查询数据
        this.dt.queryPageData()
      },
      search: function () {
        let filter = [];
        if (this.toName && this.toName !== '') {
          let key = {};
          key.name = 'toUser.name';
          key.type = 'string';
          key.value = this.toName;
          filter.push(key)
        }
        if (this.createName && this.createName !== '') {
          let key = {};
          key.name = 'createUser.staffName';
          key.type = 'string';
          key.value = this.createName;
          filter.push(key)
        }
        if (this.infoName && this.infoName !== '') {
          let key = {};
          key.name = 'customerInfo.name';
          key.type = 'string';
          key.value = this.infoName;
          filter.push(key)
        }
        if (this.beginAt && this.beginAt !== '') {
          let key = {};
          key.name = "beginAt";
          key.type = 'date';
          key.value = this.beginAt;
          filter.push(key);
        }
        this.dt.filters = filter;
        this.dt.queryPageData()
      },
      //  日期格式化
      dateFormat: function (row, column) {
        var date = row[column.property];
        if (date === undefined || date === null) {
          return "";
        }
        return this.$moment(date).format("YYYY-MM-DD");
      },
      // 布尔值格式化
      booleanFormat: function (row, column) {
        var data = row[column.property];
        if (data === undefined || data === null) {
          return "";
        }
        return data ? "是" : "否";
      },
      //  状态格式化
      commonStatusFormat: function (row, column) {
        var date = row[column.property];
        return CommonUtil.commonStatusFormat(date);
      },
      //  创建新记录
      handleCreate: function () {
        this.$router.push({path: '/memo/systemMemoModify', query: {customerId: this.customerId}});
      },
      // 编辑记录
      handleEdit: function (index, row) {
        this.$router.push({path: '/memo/systemMemoModify', query: {id: row.id, customerId: this.customerId}});
      },
      // 删除
      handleDelete: function (index, row) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = '执行中...';
              setTimeout(() => {
                this.axios.post('/admin/systemMemo/delete', [], {params: {id: row.id}})
                  .then(resp => { // 保存成功跳回列表页面
                    if (resp.data.code === 200) {
                      done();
                      this.dt.queryPageData();
                      SystemMemoService.getInstance(this).refresh(); // 刷新备忘列表
                      this.$message({
                        type: 'success',
                        message: '刪除成功'
                      });
                    } else {
                      done();
                      this.$message({
                        type: 'error',
                        message: '刪除失敗'
                      });
                    }
                  }).catch(resp => {
                  done();
                  this.$message({
                    type: 'error',
                    message: '刪除失敗'
                  });
                });
                setTimeout(() => {
                  instance.confirmButtonLoading = false
                }, 300);
              }, 1000);
            } else {
              done();
            }
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SystemMemoList.vue?b8725498